'use strict';
var ansiRegex = require('ansi-regex')();

module.exports = function (str) {
	return typeof str === 'string' ? str.replace(ansiRegex, '') : str;
};



/*****************
 ** WEBPACK FOOTER
 ** (webpack)-dev-server/~/strip-ansi/index.js
 ** module id = 265
 ** module chunks = 0
 **/